import React from "react";
import { createPortal } from "react-dom";
import "./CustomAlert.css";

export default function CustomAlert({
  title,
  message,
  type = "success", // success | error
  onClose
}) {

  // ---- Smart Message Formatter ----
  function formatMessage(msg) {
    if (!msg) return "";

    let m = msg.trim();

    // Capitalize first letter
    m = m.charAt(0).toUpperCase() + m.slice(1);

    // Special phrases
    const specialPhrases = [
      { from: "shortlisted profiles", to: "Shortlisted Profiles" },
      { from: "added to your shortlisted profiles", to: "Added to your Shortlisted Profiles" },
      { from: "added to your shortlist", to: "Added to your Shortlist" }
    ];

    specialPhrases.forEach(({ from, to }) => {
      const regex = new RegExp(from, "gi");
      m = m.replace(regex, to);
    });

    // Add period if missing
    if (!/[.!?]$/.test(m)) {
      m += ".";
    }

    return m;
  }

  const formattedMessage = formatMessage(message);

  // ---- Auto Error Detection ----
  const isError =
    type === "error" ||
    /error|failed|invalid|not found|wrong|denied/i.test(message || "");

  // ---- Component ----
  return createPortal(
    <div className="va-alert-overlay">
      <div className="va-alert-box">

        {/* ICON */}
        {/* ICON */}
        <div className={`va-alert-icon ${isError ? "error" : "success"}`}>
          {isError ? (
            /* ❌ ANIMATED ERROR ICON */
            <svg className="va-crossmark" viewBox="0 0 52 52">
              <circle
                className="va-crossmark-circle"
                cx="26"
                cy="26"
                r="24"
              />
              <line
                className="va-crossmark-line"
                x1="17"
                y1="17"
                x2="35"
                y2="35"
              />
              <line
                className="va-crossmark-line"
                x1="35"
                y1="17"
                x2="17"
                y2="35"
              />
            </svg>
          ) : (
            /* ✅ SUCCESS ICON */
            <svg className="va-checkmark" viewBox="0 0 52 52">
              <path
                className="va-checkmark-circle"
                d="M26 2 C12.3 2 2 12.3 2 26 C2 39.7 12.3 50 26 50 C39.7 50 50 39.7 50 26 C50 12.3 39.7 2 26 2 Z"
              />
              <path
                className="va-checkmark-check"
                d="M14 27 L22 35 L38 18"
              />
            </svg>
          )}
        </div>


        <h2 className="va-alert-title">{title}</h2>
        <p className="va-alert-message">{formattedMessage}</p>

        <button className="va-alert-btn" onClick={onClose}>
          OK
        </button>

      </div>
    </div>,
    document.body
  );
}
